import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 24,
	viewBox: "0 0 44 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 23,
			rx: 3.5,
			fill: "#306FC5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.61146 8L6 15.9897H10.3234L10.8594 14.7158H12.0845L12.6205 15.9897H17.3794V15.0174L17.8034 15.9897H20.2651L20.6891 14.9969V15.9897H30.5863L31.7897 14.7489L32.9166 15.9897L38 16L34.3771 12.0172L38 8H32.9954L31.824 9.21788L30.7326 8H19.9658L19.0412 10.0622L18.095 8H13.7806V8.93919L13.3006 8C13.3006 8 9.61146 8 9.61146 8ZM10.448 9.13455H12.5555L14.9509 14.5524V9.13455H17.2596L19.1098 13.0191L20.815 9.13455H23.1121V14.8677H21.7143L21.7029 10.3752L19.6652 14.8677H18.4149L16.3657 10.3752V14.8677H13.4903L12.9452 13.5824H10L9.45603 14.8666H7.91541L10.448 9.13455ZM24.3908 9.13455H30.0743L31.8126 11.0117L33.6069 9.13455H35.3452L32.704 12.016L35.3452 14.8643H33.528L31.7897 12.9654L29.9863 14.8643H24.3908V9.13455ZM11.4732 10.1046L10.5029 12.3942H12.4424L11.4732 10.1046ZM25.7943 10.3216V11.3682H28.8949V12.5347H25.7943V13.6773H29.2721L30.888 11.9944L29.3406 10.3206H25.7943V10.3216Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 23,
			rx: 3.5,
			stroke: "#EAEAEA"
		})
	]
});
export default SvgAmex;
